/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
// import { useTheme } from '@mui/material/styles';

const HTMLMessage = (props) => {
    
    const { message } = props;
    // const theme = useTheme();
    if (!message) {
        return null;
    }
    
    return (
        <>
            <span className='html-message'
                dangerouslySetInnerHTML={{ __html: message }}
            />
        </>
    );
};

export { HTMLMessage };
